import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, forwardRef } from 'react';
import { Transition } from '@headlessui/react';
import { useDialectUiId } from '../common/providers/DialectUiManagementProvider';
import Notifications from '../Notifications';
import { useTheme, } from '../common/providers/DialectThemeProvider';
import useMobile from '../../utils/useMobile';
import clsx from 'clsx';
const NotificationsModal = forwardRef(function InnerNotificationsModalWithRef({ wrapperClassName, animationStyle, dialectId, standalone, Component = Notifications, ...props }, ref) {
    var _a;
    const { modalWrapper, modalBackdrop, animations } = useTheme();
    const { ui, close } = useDialectUiId(dialectId);
    const isMobile = useMobile();
    useEffect(() => {
        // Prevent scrolling of backdrop content on mobile
        document.documentElement.classList[(ui === null || ui === void 0 ? void 0 : ui.open) && (isMobile || standalone) ? 'add' : 'remove'](...clsx('dt-overflow-hidden', 'dt-static', !standalone && 'sm:dt-overflow-auto').split(' '));
    }, [ui === null || ui === void 0 ? void 0 : ui.open, isMobile, standalone]);
    const animationKey = (animationStyle || 'popup');
    // TODO: fix types
    const animationProps = animations[animationKey];
    return (_jsxs("div", { className: "dialect dt-w-full dt-h-full", children: [(ui === null || ui === void 0 ? void 0 : ui.open) && standalone ? _jsx("div", { className: modalBackdrop }) : null, _jsx(Transition, { className: clsx(modalWrapper, wrapperClassName), show: (_a = ui === null || ui === void 0 ? void 0 : ui.open) !== null && _a !== void 0 ? _a : false, ...animationProps, children: _jsx("div", { ref: ref, className: "dt-w-full dt-h-full", children: _jsx(Component, { onModalClose: close, ...props }) }) })] }));
});
export default NotificationsModal;
//# sourceMappingURL=index.js.map